"use client";
import React from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  SelectGroup,
  SelectLabel,
  SelectSeparator
} from "../ui/select";
import { useRouter, useSearchParams } from "next/navigation";

type SizeDropdownProps = {
  sizes: string[];
};

const groupSizes = (sizes: string[]) => {
  return sizes.reduce((acc: { [key: string]: string[] }, size: string) => {
    const [groupLabel, ...rest] = size.split(" ");
    const group = acc[groupLabel] || [];
    acc[groupLabel] = [...group, rest.join(" ")]; 
    return acc;
  }, {});
};

export const SizeDropdown = ({ sizes }: SizeDropdownProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const selectedSize = searchParams.get("size") || sizes[0];

  const handleSizeChange = (size: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("size", size);
    router.replace(`?${params.toString()}`, { scroll: false });
  };

  const groupedSizes = groupSizes(sizes);

  const sortedGroupEntries = Object.entries(groupedSizes).sort(([a], [b]) =>
    a.localeCompare(b)
  );

  return (
    <Select onValueChange={handleSizeChange} defaultValue={selectedSize}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select your phone model" />
      </SelectTrigger>
      <SelectContent className="z-[999]">
        {sortedGroupEntries.map(([groupLabel, groupSizes]) => (
          <SelectGroup key={groupLabel}>
            <SelectLabel>{groupLabel}</SelectLabel>
            {groupSizes.map((size, index) => (
              <SelectItem key={index} value={`${groupLabel} ${size}`}>
                {groupLabel} {size}
              </SelectItem>
            ))}
            <SelectSeparator />
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};
